import { Observable, Subject } from 'rxjs';
import { openModal } from '@core/components/ModalStack';

/**
 * Asks why a master catalog record is changed or deleted (required). Like `showYesNo`, it emits the reason on Save
 * and completes when the window closes, so `askChangeReason(...).pipe(switchMap(changeNote => save))` saves nothing
 * when the window is closed. The server refuses those edits and deletes without a reason (CatalogActivityHelper).
 */
export function askChangeReason(title = 'Reason for Change', message?: string, button = 'Save'): Observable<string> {
  const result$ = new Subject<string>();
  import('./ChangeReasonModal').then(({ ChangeReasonModal }) => openModal(ChangeReasonModal, { title, message, button, result$ }));
  return result$;
}
